import PropTypes from 'prop-types'
import React, { useState } from 'react'
import Icon from 'blocks.simple/icon/icon'
import Range from '../range'
import styles from './range_volume.jcss'
import { defaultThemeStyles } from '../Range-theme'
import { getThemeStyleValue } from '../../../theme/colors'
import { color } from 'theme/tokens/color'
import { cn } from 'ethcss'
import type { RangeVolumeIcons, RangeVolumeProps } from '../range.types'

const VOLUME_RANGE_STEP = 5

const RangeVolume = ({
    disabled,
    handle,
    icons: customIcons,
    mod = 'darkBlue',
    iconMod = '',
    onAfterChange = () => {},
    onChange,
    showVolumeCounter = true,
    volume = 0,
}: RangeVolumeProps) => {
    const [offset, setOffset] = useState(0)
    const icons: RangeVolumeIcons = {
        max: 'volume_max',
        min: 'volume_mute',
        stepUp: 'volume_plus',
        stepDown: 'volume_minus',
        ...customIcons,
    }

    const changeVolume = (type: string) => {
        let value = volume

        if (type === 'plus') {
            value = volume > 95 ? 100 : volume + VOLUME_RANGE_STEP
        }

        if (type === 'minus') {
            value = volume < VOLUME_RANGE_STEP ? 0 : volume - VOLUME_RANGE_STEP
        }

        onChange(value)
        onAfterChange(value)
    }

    const volumeMinStateIcon = volume ? icons.stepDown : icons.min
    const volumeMaxStateIcon = volume === 100 ? icons.max : icons.stepUp
    const isWhite = mod === 'white'
    const iconColor = isWhite
        ? color.iconWhiteHigh
        : iconMod || getThemeStyleValue('ui', 'range', 'icon') || defaultThemeStyles.icon

    return (
        <div className={cn(styles.wrapper, disabled ? styles.disabled : '')}>
            <div className={styles.icon}>
                <Icon
                    type={volumeMinStateIcon}
                    size="18"
                    color={iconColor}
                    onClick={function () {
                        changeVolume('minus')
                    }}
                />
            </div>
            <div className={styles.range}>
                {showVolumeCounter && (
                    <div className={cn(styles.counter, isWhite && styles.counterWhite)} style={{ left: `${offset}%` }}>
                        {parseInt(offset.toString(), 10)}%
                    </div>
                )}
                <Range
                    range
                    min={0}
                    max={100}
                    mod={mod}
                    value={volume}
                    handle={handle}
                    onChange={onChange}
                    onAfterChange={onAfterChange}
                    getHandleOffset={(offset) => {
                        setOffset(offset)
                    }}
                />
            </div>
            <div className={styles.icon}>
                <Icon
                    type={volumeMaxStateIcon}
                    size="18"
                    color={iconColor}
                    onClick={function () {
                        changeVolume('plus')
                    }}
                />
            </div>
        </div>
    )
}

RangeVolume.propTypes = {
    onChange: PropTypes.func.isRequired,
    onAfterChange: PropTypes.func,
    handle: PropTypes.bool,
    mod: PropTypes.string,
    iconMod: PropTypes.string,
    volume: PropTypes.number,
    icons: PropTypes.shape({
        min: PropTypes.string,
        max: PropTypes.string,
        stepDown: PropTypes.string,
        stepUp: PropTypes.string,
    }),
    showVolumeCounter: PropTypes.bool,
}

export default RangeVolume
